import { apiRequest } from '../../../api/client';
import type { MachineWorkspaceResponseDto } from '../types/machine-memory';

export function getMachineWorkspace(machineId: string) {
  return apiRequest<MachineWorkspaceResponseDto>(`/v1/machines/${encodeURIComponent(machineId)}/workspace`);
}
